export default "__VITE_ASSET__BCyB5tWI__"